import { Directive, ElementRef, Input } from '@angular/core';
import { first, switchMap } from 'rxjs/operators';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { of } from 'rxjs';
import { ToastEnum } from '../enums/toast.enum';
import { MessageService } from 'primeng/api';
import { PermissionService } from '../services/permission.service';

@Directive({
  selector: '[appPermissions]'
})
export class PermissionsDirective {
  @Input('appPermissions') permissionKey!: number | number[];
  @Input() isPermissionHidden: boolean = false;
  @Input() isLinkShowTooltip: boolean = false;
  private static toastShown = false;
  public permissionKeys: number[] = [];
  private isNotShowPermissionToast: number[] = [53, 57, 62, 74, 71];
  constructor(
    private el: ElementRef,
    private permissionService: PermissionService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.permissionKeys = Array.isArray(this.permissionKey)
      ? this.permissionKey
      : [this.permissionKey];
    this.permissionService
      .getPermissionsFromCache()
      .pipe(
        switchMap((permissions) =>
          PermissionService.isLoading ? of(permissions) : this.permissionService.fetchPermissions()
        ),
        first((value) => !!value),
        untilDestroyed(this)
      )
      .subscribe((permissions) => {
        const hasPermission = this.permissionKeys.some((key) => permissions[key]);
        this.toggleElementState(hasPermission);
        if (
          !hasPermission &&
          !PermissionsDirective.toastShown &&
          !this.isNotShowPermissionToast.includes(
            this.permissionKeys.find((key) => !permissions[key])
          )
        ) {
          PermissionsDirective.toastShown = true;
          this.showPermissionToast();
        }
      });
  }

  private toggleElementState(result: boolean): void {
    const element = this.el.nativeElement;
    if (!result && !this.isPermissionHidden) {
      if (this.isLinkShowTooltip) {
        element.setAttribute('title', 'У Вас недостаточно прав доступа для совершения действия');
      } else {
        element.style.pointerEvents = 'none';
      }
      element.setAttribute('disabled', 'disabled');
      element.style.cursor = 'default';
      element.style.opacity = '0.7';
      element.classList.add('permission-blocked');
      element.addEventListener('click', this.preventDefaultClick);
    } else if (!result && this.isPermissionHidden) {
      element.style.display = 'none';
    }
  }

  public showPermissionToast() {
    this.messageService.add({
      sticky: true,
      styleClass: 'permission-warn',
      detail: 'У Вас недостаточно прав доступа для совершения некоторых действий.',
      data: {
        typeEnum: ToastEnum.warnToast,
      },
    });
  }

  private preventDefaultClick(event: Event): void {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  ngOnDestroy(): void {}
}
